import { createSelectorCreator, lruMemoize, weakMapMemoize } from 'reselect';

/**
 * App-wide selector creator: use it for any selector with an input selector
 * that returns a primitive (an id, a string from the URL, a date, a flag).
 *
 * Uses weakMapMemoize for argsMemoize (multi-arg caching)
 * and lruMemoize for the inner memoize layer (bounded, SSR-safe).
 *
 * The default createSelector (reselect 5 and RTK 2) uses weakMapMemoize for
 * the inner layer too. It caches input-selector results in a tree that keeps
 * primitives in strong Map nodes that are never evicted, so on the server
 * every distinct id rendered stays in memory for the life of the process
 * (#1231). This depends on what the input selectors return, not on how many
 * arguments the selector takes: a selector over (state) alone leaks if one
 * of its inputs returns a primitive such as a device id.
 *
 * memoizeOptions.maxSize is 1. A selector called with alternating arguments
 * in one render needs a larger maxSize so each call does not evict the
 * other's result (see selectUrlFilterParams).
 */
export const createAppSelector = createSelectorCreator({
    argsMemoize: weakMapMemoize,
    memoize: lruMemoize,
    memoizeOptions: { maxSize: 1 },
});
